import clsx from 'clsx';
import React from 'react';
import _isString from 'lodash/isString';
import _isArray from 'lodash/isArray';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { Text } from '@lifeomic/chroma-react/components/Text';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1.25, 2.5),
    width: '100%',
  },
  highlighted: {
    backgroundColor: 'rgba(222,244,252, 0.6)',
  },
  title: {
    color: theme.palette.black[700],
    wordBreak: 'break-word',
  },
  subtitle: {
    color: theme.palette.black[400],
    wordBreak: 'break-word',
  },
}));

export interface AutoSuggestListItemProps {
  isHighlighted: boolean;
  subtitle?: string | Array<string>;
  title: string;
}

export const AutoSuggestListItem: React.FC<AutoSuggestListItemProps> = ({
  isHighlighted,
  subtitle,
  title,
  ...restProps
}) => {
  const classes = useStyles({});

  return (
    <div
      role="button"
      className={clsx(classes.root, {
        [classes.highlighted]: isHighlighted,
      })}
      {...restProps}
    >
      {title && (
        <Text className={classes.title} size="body">
          {title}
        </Text>
      )}
      {_isString(subtitle) && (
        <Text className={classes.subtitle} size="caption">
          {subtitle}
        </Text>
      )}
      {_isArray(subtitle) &&
        subtitle.map((s: string, key: number) => (
          <Text key={key} className={classes.subtitle} size="caption">
            {s}
          </Text>
        ))}
    </div>
  );
};
